// schema/nodes/heading.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
var HEADING_SCHEMA = () => ({
  attrs: { level: { default: 1, validate: "number" }, textAlign: { default: "left" } },
  content: "inline*",
  group: "block",
  defining: true,
  parseDOM: parseDOMPossibilities(),
  toDOM: (node) => {
    const blockMargin = `calc(32px - (${node.attrs.level - 1} * 4px))`;
    return [
      `${DesignSystem.prefix}-h${node.attrs.level}`,
      {
        style: `text-align: ${node.attrs.textAlign}; margin-block-start: ${blockMargin}; margin-block-end: ${blockMargin}`
      },
      0
    ];
  }
});
var HEADING_KEY = "heading";
var HEADING = {
  [HEADING_KEY]: HEADING_SCHEMA
};
function parseDOMPossibilities() {
  const result = [];
  for (let i = 0; i < 6; i++) {
    const level = i + 1;
    const getAttrs = (dom) => {
      const style = dom.getAttribute("style") || "";
      const textAlignMatch = /text-align:\s*(\w+)/.exec(style);
      return {
        level,
        textAlign: textAlignMatch ? textAlignMatch[1] : "left"
        // Standardwert ist 'left', wenn nichts gefunden wird
      };
    };
    result.push({ tag: `h${level}`, getAttrs });
    result.push({ tag: `x-h${level}`, getAttrs });
    if (DesignSystem.prefix !== "x")
      result.push({ tag: `${DesignSystem.prefix}-h${level}`, getAttrs });
  }
  return result;
}
export {
  HEADING,
  HEADING_KEY,
  HEADING_SCHEMA
};
